import { Typography } from "@mui/material";
import { AnonymousLayout } from "Components/Layout/AnonymousLayout";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { useNavigate } from "Navigation/useNavigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Pages.Content.AnonymousDashboard;

export const AnonymousDashboardPage = () => {
  const navigate = useNavigate();
  const { t } = useResource();

  return (
    <AnonymousLayout title="">
      <Typography marginBottom={8} variant="h6">
        {t(RESOURCES.RegistrationRequired)}
      </Typography>
      <PrimaryButton
        fullWidth
        color="primary"
        onClick={() => navigate(appUrl("sign-up"))}
      >
        {t(RESOURCES.Register)}
      </PrimaryButton>
    </AnonymousLayout>
  );
};
